exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "team-requests-modal-approve-all .modal-dialog{width:520px;height:350px}team-requests-modal-approve-all .modal-dialog .modal-content .modal-body .description{margin-bottom:0}team-requests-modal-approve-all .modal-dialog .modal-content .modal-footer{margin-top:51px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/vacations-absences.module/features/teamRequests/teamRequestsModalApproveAll/teamRequestsModalApproveAll.scss
// module id = 1279
// module chunks = 0